import React, { Component } from 'react';
import { __, __n } from 'i18n-for-browser';
import { Link } from 'react-router-dom';

import ListButton from '../elements/ListButton';
import Table from '../elements/Table';
import { icons } from '../../assets/assets';
import GameDetails from '../elements/GameDetails';
import connect from "react-redux/es/connect/connect";
import apiCall from "../apiCall";
import actions from "../../actions";
import PopUp from "../elements/PopUp";
import Loading from "../elements/Loading";
import { cookie } from 'glxl-helpers';
import config from '../../config';

const { refreshProject } = actions.project;

let activeTab = 0;

class SchoolPortalHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: activeTab || 0,
      showGroepsIndeling: sessionStorage.getItem('showGroepsIndeling') || false,
      confirmDeletion: false,
      deletionId: null,
      schoolClasses: [],
      fetched: false,
      downloading: [],
    }
    if (sessionStorage.getItem('showGroepsIndeling')) {
      sessionStorage.setItem('showGroepsIndeling', '');
    }
  }

  componentWillReceiveProps(props) {
    if (props.project.id && !this.state.fetched) {
      apiCall(`/schoolClass/overview/${props.project.id}`)
        .then((schoolClasses) => {
          this.setState({
            schoolClasses,
            fetched: true,
          });
        });
    }
  }

  componentWillMount() {
    if (this.props.project.id && !this.state.fetched) {
      apiCall(`/schoolClass/overview/${this.props.project.id}`)
        .then((schoolClasses) => {
          this.setState({
            schoolClasses,
            fetched: true,
          });
        });
    }

    document.body.classList.add('schoolPage');
  }

  toggleTab = (no) => {
    activeTab = no;
    this.setState({
      activeTab: no
    })
  };

  deleteClass = (classId) => {
    const { schoolClasses } = this.state;

    apiCall(`/schoolClass/${classId}`, null, 'DELETE');

    let classIndex = 0;

    schoolClasses.forEach(function (c, i) {
      if (c.id === classId) {
        classIndex = i;
      }
    });

    schoolClasses.splice(classIndex, 1);

    this.props.dispatch(refreshProject());
    this.setState({
      confirmDeletion: false,
      deletionId: null
    });
  };

  toggleDeletionPopup = (ev, classId = null) => {
    ev.preventDefault();
    let parent = ev.target.parentElement;

    let closeButton = false;

    while (parent) {
      if (parent.classList.contains('close-button')) {
        closeButton = true;
      }

      if (!closeButton) {
        if (parent.classList.contains('popup')) {
          return false;
        }
      }

      parent = parent.parentElement;
    }

    if (this.state.confirmDeletion) {
      this.setState({
        confirmDeletion: false,
        deletionId: null
      });
    } else {
      this.setState({
        confirmDeletion: true,
        deletionId: classId
      });
    }
  };

  downloadPdf = async (type) => {
    if (this.state.downloading.includes(type)) return false;
    const token = cookie.getCookie('token');
    window.open(`${config.apiUrl}/pdf/${type}/${this.props.project.id}?authorization=${token}`, '_blank');
  };

  getTabPage = () => {
    const { project } = this.props;
    const { schoolClasses } = this.state;

    const classes = schoolClasses;

    let classObject = [];

    if (classes) {
      classes.forEach(function (klas) {
        if (klas.id) {
          classObject.push([klas.className, klas.classRoom, klas.StudentsCount, project.schoolClassesLocked ? null : (
            <div className='editButtons'>
              <Link to={'/portal/school/class/' + klas.id}><img src={icons.pen} alt={'pen'} /></Link>
              <img src={icons.trash} alt={'trash'} onClick={(ev) => {
                this.toggleDeletionPopup(ev, klas.id)
              }} />
            </div>
          )])
        }
      }, this)
    }

    switch (this.state.activeTab) {
      //Voorbereiding
      case 0:
        return (
          <div className='container'>
            <div>
              <ListButton bgColor='blue' icon={icons.groepsbewerk} title={__('sim_groepsindeling_invoeren')} onClick={() => this.setState({ showGroepsIndeling: !this.state.showGroepsIndeling })} />
              {this.state.showGroepsIndeling ?
                <div className="fade-in dropdownSpacing">
                  {classObject.length ?
                    <Table
                      className="school-portal-table"
                      head={[__n('sim_klas', 1), __n('sim_lokaal', 1), __n('sim_leerling', 0), '']}
                      body={
                        classObject
                      }
                    />
                    : null}
                  <div className="buttonRow buttonRow--wide buttonRow--spacing-top">
                    {project.schoolClassesLocked ? null :
                      <Link className='button button--darkblue'
                        to={'/portal/school/class/add'}><span>{__("sim_klas_toevoegen")}</span></Link>
                    }
                    <button className={`button${(this.state.downloading.includes('projectGroupLayouts') ? ' disabled' : '')}`} onClick={() => { this.downloadPdf('projectGroupLayouts'); }}><span>PDF {__('sim_groepsindeling')}</span></button>
                  </div>
                </div> : null}
              <Link to="/portal/school/test">
                <ListButton bgColor='blue' icon={icons.testen} title={__('sim_test_systeembeheer')} />
              </Link>
              {this.props.project.accompaniment === "docenten" ? (
                <ListButton bgColor='blue' icon={icons.checklist} title={__('sim_voorbereiding_docenten')} onClick={() => {
                  window.open(`/portal/school/voorbereiding/${this.props.project.id}/${this.props.project.DefaultLanguageId}/${this.props.project.DefaultDifficultyId}`);
                  return false;
                }} />
              ) : null}
            </div>
          </div>
        );
      //Afronding
      case 1:
        return (
          <div className='container'>
            <div className="content-container">
              <div className="content-container-background" />

              <div className="score-row score-row--margin-bottom">
                <p>{__('sim_eindstand')}</p>
                <p className="links"><a className={`${(this.state.downloading.includes('eindstand') ? 'disabled' : '')}`} href="" onClick={(ev) => { ev.preventDefault(); this.downloadPdf('eindstand'); }}>{__('sim_pdf_eindstand')}</a></p>
              </div>
              <div className="score-row score-row--margin-bottom">
                <p>{__('sim_eindcijfers')}</p>
                <p className="links"><a className={`${(this.state.downloading.includes('eindcijfers') ? 'disabled' : '')}`} href="" onClick={(ev) => { ev.preventDefault(); this.downloadPdf('eindcijfers'); }}>{__('sim_pdf_eindcijfers')}</a></p>
              </div>
              <div className="score-row score-row--margin-bottom">
                <p>{__('sim_fotos_downloaden')}</p>
                <p className="links"><Link to={`/portal/school/media/${this.props.project.id}`}>{__('sim_link')}</Link></p>
              </div>
              <div className="score-row score-row--margin-bottom">
                <p>{__('sim_schrijf_een_review')}</p>
                <p className="links">
                  {/*<a href="http://www.facebook.com/pg/crossyourborders/reviews"*/}
                  {/*rel="noopener noreferrer"*/}
                  {/*target='_blank'>{__('Facebook')}</a>&nbsp;&nbsp;*/}
                  <a href="http://goo.gl/H4yB1z"
                    rel="noopener noreferrer"
                    target='_blank'>{__('Google')}</a>
                </p>
              </div>
            </div>
          </div>
        );
      default:
        return;
    }
  }

  render() {
    if (!this.state.fetched) {
      return <Loading />;
    }
    return (
      <div className="portal-home portal-school">
        <div className="desktop-content-center">
          <GameDetails />
          <div className="buttonRow">
            <button className={`tab ${this.state.activeTab === 0 ? 'button--darkblue' : 'button--white'}`} onClick={() => this.toggleTab(0)}><span>{__('sim_voorbereiding')}</span></button>
            <button className={`tab ${this.state.activeTab === 1 ? 'button--darkblue' : 'button--white'}`} onClick={() => this.toggleTab(1)}><span>{__('sim_afronding')}</span></button>
          </div>
          {this.getTabPage()}
        </div>
        {
          this.state.confirmDeletion
            ? <PopUp
              title={__('sim_verwijderen')}
              description={__('sim_bevestig_klas_verwijderen_melding')}
              showPopUp={true}
              closePopUpCross={true}
              customButton={{
                text: __('sim_verwijderen'),
                action: () => this.deleteClass(this.state.deletionId),
              }}
              closePopUpClick={(ev) => this.toggleDeletionPopup(ev)}
            />
            : null
        }
      </div>
    );
  }
}

export default connect(state => ({
  project: state.project,
}))(SchoolPortalHome);



// WEBPACK FOOTER //
// ./src/components/desktop/SchoolPortalHome.js